import { render, staticRenderFns } from "./DatatableBody.vue?vue&type=template&id=3c5eb600&"
import script from "./DatatableBody.vue?vue&type=script&lang=js&"
export * from "./DatatableBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports